import Vue from 'vue'
import './components'
import './plugins'
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import axios from 'axios'
import Init from '@/Init'

// Sync store with router
sync(store, router)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

// Global http with axios
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Token-Auth'] = store.state.token !== null ? store.state.token : null

axios.interceptors.request.use(function (config) {
  let hash = config.url
  hash = hash.replace(/[^a-z0-9]/gi, '')

  setTimeout(() => { store.dispatch('loader/change', { requester: hash, mode: true }) }, 1000)

  return config
}, function (error) {
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  let hash = response.request.responseURL
  hash = hash.replace(/[^a-z0-9]/gi, '')

  setTimeout(() => { store.dispatch('loader/change', { requester: hash, mode: false }) }, 1000)

  return response
}, function (error) {
  let hash = error.request.responseURL
  hash = hash.replace(/[^a-z0-9]/gi, '')

  setTimeout(() => { store.dispatch('loader/change', { requester: hash, mode: false }) }, 1000)

  return Promise.reject(error)
})

Vue.prototype.$http = axios
// end global http

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Load common data only logged.
Init()
